module.exports = __webpack_public_path__ + "static/media/crdit-card-alt.849681fb.svg";